// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store/'
import {
  VueAxios
} from './utils/request'
import {
  Pagination
} from 'ant-design-vue'
import './config/rem'
// mock
// WARNING: `mockjs` NOT SUPPORT `IE` PLEASE DO NOT USE IN `production` ENV.
import './mock'
// import bootstrap from './core/bootstrap'
import './core/lazy_use'
import './core/mixins'
import './permission' // permission control
import './utils/filter' // global filter
import './components/global.less'
import './components/global.stylus'
import leftMenu from '@/components/LeftMenu'
import '@/core/directives'

// 开票系统新增组件
import MTable from '@/components/MTable/table.vue'
import popModal from '@/components/popModal/popModal'
// 打印插件
import Print from '@/components/vuePlugs_printjs-master/print.js'

import globel from './utils/globel.js'

Vue.component(Pagination.name, Pagination)

// 开票系统新增
Vue.component('MTable', MTable)
Vue.component('popModal', popModal)

Vue.use(leftMenu)
Vue.config.productionTip = false
Vue.prototype.$globel = globel // 用于统一管理接口
Vue.use(Print)
// mount axios Vue.$http and this.$http
Vue.use(VueAxios)
const vm = new Vue({
  router,
  store,
  // created: bootstrap,
  render: h => h(App)
}).$mount('#app')
export default vm
